export default __webpack_public_path__ + "static/media/19.85cdab18.pdf";